import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const routeTitleMap: Record<string, string> = {
  "/": "Agents • Forgeworks",
  "/auth": "Login • Forgeworks",
  "/settings": "Settings • Forgeworks",
  "/integrations": "Integrations • Forgeworks",
  "/customers": "Customers • Forgeworks",
  "/contracts": "Contracts • Forgeworks",
  "/field-mapping": "Field Mapping • Forgeworks",
  "/hubspot-agent": "Data Agent • Forgeworks",
  "/contract-intelligence/setup": "RevSync • Forgeworks",
  "/user-management": "User Management • Forgeworks",
  "/subscription-tier-selection": "Subscription • Forgeworks",
  "/asana-agent/landing-page": "Asana Agent • Forgeworks",
  "/revops-agent/landing-page": "RevOps Agent • Forgeworks",
  "/reset-password": "Reset Password • Forgeworks",
  "/verify-email": "Verify Email • Forgeworks",
  "/accept-invitation": "Accept Invitation • Forgeworks",
  "/terms": "Terms • Forgeworks",
  "/privacy": "Privacy Policy • Forgeworks",
  "/roles": "Roles & Permissions • Forgeworks",
  "/hubspot/display": "HubSpot • Forgeworks",
  "/hubspot/success": "HubSpot Success • Forgeworks",
  "/hubspot/error": "HubSpot Error • Forgeworks",
  "/hubspot/documentation": "HubSpot Docs • Forgeworks",
  "/stripe/success": "Stripe Success • Forgeworks",
  "/stripe/error": "Stripe Error • Forgeworks",
  "/slack/success": "Slack Success • Forgeworks",
  "/slack/error": "Slack Error • Forgeworks",
  "/asana/success": "Asana Success • Forgeworks",
  "/asana/error": "Asana Error • Forgeworks",
  "/api/landing-page": "API • Forgeworks",
  "/api/unknown": "Unknown • Forgeworks",
};

export const usePageTitle = () => {
  const location = useLocation();

  useEffect(() => {
    // Check for exact match first
    let title = routeTitleMap[location.pathname];

    // If no exact match, check for dynamic routes
    if (!title) {
      // Handle /contracts/:id route
      if (
        location.pathname.startsWith("/contracts/") &&
        location.pathname !== "/contracts"
      ) {
        title = "Contract Details • Forgeworks";
      }
    }

    document.title = title || "Forgeworks";
  }, [location.pathname]);
};
